import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../shared';

import { DASHBOARD_ROUTE, DashboardComponent } from './';

@NgModule({
    imports: [
        JYoguiSharedModule,
        NgxChartsModule,
        RouterModule.forRoot([DASHBOARD_ROUTE], { useHash: true })
    ],
    declarations: [
        DashboardComponent,
    ],
    entryComponents: [
    ],
    providers: [
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiDashboardModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/dashboard/dashboard.module.ts